import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EvaluationSlideshowModal from './EvaluationSlideShowModal';
import { useI18nTierKeys } from 'setup-guide-api/hooks/productLevels';
import { ONBOARDING_VIEWS } from 'onboarding-settings-client/constants/onboardingViews';
import { getServiceEvaluationModalSteps } from '../../constants/serviceEvaluationConstants';
import { useHasHelpDeskAccess } from '../../hooks/auth';
import { CONNECT_INBOX_URL, HELP_DESK_CONNECT_EMAIL_URL } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ServiceEvaluationSlideshowModal = props => {
  const {
    capitalizedTier
  } = useI18nTierKeys(ONBOARDING_VIEWS.SERVICE);
  const hasHelpDeskAccess = useHasHelpDeskAccess();
  return /*#__PURE__*/_jsx(EvaluationSlideshowModal, Object.assign({}, props, {
    buttonProps: {
      href: hasHelpDeskAccess ? HELP_DESK_CONNECT_EMAIL_URL : CONNECT_INBOX_URL
    },
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.serviceEvaluation.cta"
    }),
    steps: getServiceEvaluationModalSteps(capitalizedTier),
    trackingName: "service evaluation slideshow modal"
  }));
};
ServiceEvaluationSlideshowModal.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default ServiceEvaluationSlideshowModal;